// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__hJcX0","pages":"PageContent_pages__ed81W"};